import { apiSlice } from "@/redux/apiSlice";
import {
  BankPaymentInitiateRequest,
  BankPaymentInitiateResponse,
  BankPaymentCallbackResponse,
} from "@/types/bank-payment";

export const bankPaymentApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      initiateBankPayment: builder.mutation<
        BankPaymentInitiateResponse,
        BankPaymentInitiateRequest
      >({
        query: ({ authorization, ...payload }) => ({
          url: "/payments/execute",
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: authorization,
          },
          body: payload,
        }),
        invalidatesTags: ["BankPayment"],
      }),
      getBankPaymentCallback: builder.mutation<
        BankPaymentCallbackResponse,
        { token: string }
      >({
        query: ({ token }) => ({
          url: `/bank/callback`,
          method: "POST",
          body: { token },
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["BankPayment"],
      }),
    };
  },
});

export const {
  useInitiateBankPaymentMutation,
  useGetBankPaymentCallbackMutation,
} = bankPaymentApi;
